export default __webpack_public_path__ + "static/media/sub-class.c9575abd.svg";